import Vue from 'vue';
import axios from 'axios';

class AppDownloadService {
  public openDocument(doc: Blob, title?: string) {
    const nav = window.navigator as any;
    if (nav && nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(doc, title);
    } else {
      const fileURL = URL.createObjectURL(doc);
      const w = window.open(fileURL, '_blank');
      if (w && title) {
        const setTitle = (): void => {
          w.document.title = title;
        };
        //fix to set the title of the tab, not very nice but best option see for additional info https://dev.azure.com/tjip/AbnAmro/_workitems/edit/83169
        w.setTimeout(setTitle, 1500);
        //trigger again for slow computers
        w.setTimeout(setTitle, 4000);
      }
    }
  }

  public saveDocument(doc: Blob, fileName: string) {
    const nav = window.navigator as any;
    if (nav && nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(doc, fileName);
    } else {
      const fileURL = URL.createObjectURL(doc);
      const lnk = window.document.createElement('a');
      lnk.href = fileURL;
      lnk.download = fileName;
      lnk.target = '_blank';
      lnk.click();
    }
  }

  public download(url: string): Promise<void> {
    return axios({
      method: 'GET',
      url,
      responseType: 'blob'
    })
      .then(response => {
        this.openDocument(response.data, url);
      })
      .catch(err => {
        Vue.$log.debug(err);
      });
  }
}

export const appDownloadService = new AppDownloadService();
